import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const MemberManageRoute = lazyWithRetries(() => import('.'))
const MemberRoute = lazyWithRetries(() => import('./member'))
const MembersBulkImportCsvRoute = lazyWithRetries(() => import('./membersBulkImportCsv'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.members(':tab?'),
    element: (
      <StandardPageLayout
        elementId="memberManageRoute"
        maxWidth="100%"
        title={<T _str="Users & teams" />}>
        <Suspense fallback={<RouteLoading />}>
          <MemberManageRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.member(':id', ':tab?'),
    element: (
      <StandardPageLayout elementId="memberRoute" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <MemberRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.membersBulkImportCsv(),
    element: (
      <StandardPageLayout
        title={<T _str="Bulk import users" />}
        elementId="membersImportCsvRoute"
        maxWidth={900}>
        <Suspense fallback={<RouteLoading />}>
          <MembersBulkImportCsvRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
